import React from 'react';
import { ProductNotFoundImage } from '../../../assets/images';
import Image from 'next/image';

const ProductNotFound = ({ containerClassName = '' }: { containerClassName?: string }) => {
  return (
    <div
      className={`container flex flex-col justify-center items-center h-[524.5px] lg:h-[670px] ${containerClassName}`}
    >
      <Image
        className="h-[200px] w-auto"
        src={ProductNotFoundImage.src}
        alt="product not found image"
        width={200}
        height={200}
      />
      <h2 className="text-reliableBlack text-xl lg:text-2xl font-bold mb-2 mt-[19px] lg:mt-6">
        Pencarian Tidak Ditemukan
      </h2>
      <p className="text-reliableBlack text-sm lg:text-lg text-center lg:max-w-[767px]">
        Maaf, sepertinya pencarian Anda tidak ditemukan, silakan coba kata kunci lain atau atur
        kombinasi filter
      </p>
    </div>
  );
};

export default ProductNotFound;
